import axios from 'axios';

/**
 * Cliente de correos (30/10): buzones, listas y licencias compartidas, correos secundarios y el
 * buscador de grupos del directorio. Todo cuelga del router del NÚCLEO (`/api`), no del de
 * Incorporaciones: con aquel módulo apagado, esto sigue funcionando.
 *
 * Las funciones devuelven `r.data` y DEJAN PASAR el error: quien llama decide qué enseñar. El
 * mensaje del servidor (409 «Ese correo ya es el buzón…») se saca con `mensajeDeError`.
 */
const API = axios.create({ baseURL: `${process.env.REACT_APP_API_URL}/api` });
API.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

/** El `message` del servidor, o el texto de reserva si no hay respuesta (red caída, 500 sin cuerpo). */
export const mensajeDeError = (e, reserva) => (e && e.response && e.response.data && e.response.data.message) || reserva;

// — Cuentas compartidas (personas.correos.gestionar)
export const listarCuentas = () => API.get('/cuentas-compartidas').then((r) => r.data);
export const opcionesCuentas = () => API.get('/cuentas-compartidas/opciones').then((r) => r.data);
export const crearCuenta = (payload) => API.post('/cuentas-compartidas', payload).then((r) => r.data);
export const editarCuenta = (id, payload) => API.put(`/cuentas-compartidas/${id}`, payload).then((r) => r.data);
export const borrarCuenta = (id) => API.delete(`/cuentas-compartidas/${id}`).then((r) => r.data);
export const anadirPersonaCuenta = (id, ambito, personaId) =>
  API.post(`/cuentas-compartidas/${id}/personas`, { ambito, persona_id: personaId }).then((r) => r.data);
export const quitarPersonaCuenta = (id, ambito, personaId) =>
  API.delete(`/cuentas-compartidas/${id}/personas/${ambito}/${personaId}`).then((r) => r.data);
/** Para PersonaPickerMiembro: devuelve `{ personas: [{ id, nombre, email, tipo }] }`. */
export const buscarPersonasParaCuenta = (q, ambito) =>
  API.get('/cuentas-compartidas/personas/buscar', { params: { q, ambito } }).then((r) => r.data);

// — Correos de una persona interna (leer: roles de la ficha; escribir: personas.correos.gestionar)
export const correosDePersona = (personaId) => API.get(`/personas/${personaId}/correos`).then((r) => r.data);
export const anadirSecundario = (personaId, payload) => API.post(`/personas/${personaId}/correos`, payload).then((r) => r.data);
export const editarSecundario = (personaId, correoId, payload) =>
  API.put(`/personas/${personaId}/correos/${correoId}`, payload).then((r) => r.data);
export const borrarSecundario = (personaId, correoId) => API.delete(`/personas/${personaId}/correos/${correoId}`).then((r) => r.data);

// — Buscador del directorio (sólo sesión): buzones y listas, sin licencias
export const buscarGrupos = (q) => API.get('/correos/buscar', { params: { q } }).then((r) => r.data);

export const CLAVE_GESTIONAR = 'personas.correos.gestionar';
export const RUTA_BUZONES = '/gestionpersonas/buzones-y-listas';

export const TIPOS_CUENTA = {
  buzon: { label: 'Buzón compartido', corto: 'Buzón', pestana: 'Buzones compartidos', badge: 'info' },
  lista: { label: 'Lista de distribución', corto: 'Lista', pestana: 'Listas de distribución', badge: 'primary' },
  licencia: { label: 'Licencia con correo propio', corto: 'Licencia', pestana: 'Licencias', badge: 'warning' },
};
export const TIPOS_SECUNDARIO = { alias: 'Alias', cuenta_adicional: 'Cuenta adicional' };
